import * as React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { PageFrame } from "./PageFrame";
import { Home } from "./Home";
import { Test } from "./Test";
import { Four04 } from "./Four04";

export const AppRoutes = (): React.JSX.Element => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PageFrame />}>
          <Route path="home" element={<Home />} />
          <Route path="test" element={<Test />} />
          <Route index element={<Navigate to="/home" replace />} />
          <Route path="*" element={<Four04 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};
